const SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbxJUhjfz6bf6q4pB6nhjqnZJZ1g9zm9129VKj4xXm9KWGRCSBYM8Gv3PKBgUcvetTur/exec';

function jsonp(url) {
  return new Promise((resolve, reject) => {
    const cb = 'cb_' + Date.now() + '_' + Math.random().toString(36).slice(2);
    const script = document.createElement('script');
    script.src = url + '&callback=' + cb;
    window[cb] = (data) => {
      delete window[cb];
      if (document.body.contains(script)) document.body.removeChild(script);
      resolve(data);
    };
    script.onerror = () => { delete window[cb]; reject(new Error('JSONP error')); };
    document.body.appendChild(script);
  });
}

export async function getVentas() {
  return jsonp(SCRIPT_URL + '?action=getVentas');
}

export async function updateEstado(rowIndex, estado) {
  await fetch(SCRIPT_URL, {
    method: 'POST', mode: 'no-cors',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ action: 'updateEstado', rowIndex, estado })
  });
}

export async function updateNota(rowIndex, nota) {
  await fetch(SCRIPT_URL, {
    method: 'POST', mode: 'no-cors',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ action: 'updateNota', rowIndex, nota })
  });
}

export async function updateEstadoYNota(rowIndex, estado, nota) {
  await fetch(SCRIPT_URL, {
    method: 'POST', mode: 'no-cors',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ action: 'updateEstadoYNota', rowIndex, estado, nota })
  });
}

/* ===== Inventario (STOCK) ===== */

export async function getStock() {
  return jsonp(SCRIPT_URL + '?action=getStock');
}

export async function addStockItem(item) {
  await fetch(SCRIPT_URL, {
    method: 'POST', mode: 'no-cors',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ action: 'addStockItem', ...item })
  });
}

export async function updateStockItem(rowIndex, item) {
  await fetch(SCRIPT_URL, {
    method: 'POST', mode: 'no-cors',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ action: 'updateStockItem', rowIndex, ...item })
  });
}

export async function deleteStockItem(rowIndex) {
  await fetch(SCRIPT_URL, {
    method: 'POST', mode: 'no-cors',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ action: 'deleteStockItem', rowIndex })
  });
}

/* uploadStockImage necesita devolver foto_url de forma síncrona,
   por lo que se usa JSONP (GET) en lugar de fetch no-cors. */
export async function uploadStockImage(base64, filename, mimeType) {
  return jsonpPost({ action: 'uploadStockImage', base64, filename, mimeType });
}

function jsonpPost(payload) {
  return new Promise((resolve, reject) => {
    const cb = 'cb_' + Date.now() + '_' + Math.random().toString(36).slice(2);
    const script = document.createElement('script');
    const params = new URLSearchParams();
    Object.entries(payload).forEach(([k, v]) => params.append(k, v));
    params.append('callback', cb);
    script.src = SCRIPT_URL + '?' + params.toString();
    window[cb] = (data) => {
      delete window[cb];
      if (document.body.contains(script)) document.body.removeChild(script);
      resolve(data);
    };
    script.onerror = () => { delete window[cb]; reject(new Error('JSONP error')); };
    document.body.appendChild(script);
  });
}
